import { Box, Typography, Tabs, Tab } from '@mui/material';
import { common } from '@mui/material/colors';
import { QuestionType } from 'pages/admin/campaign-overview/constants';
import React, { useEffect } from 'react';
import { DisplayType } from '../constants';
import { useAppSelector } from 'common/hook';
import { RootState } from 'plugins/store';
import { createStyleSheet } from 'utils/helpers';
import { colors } from 'common/constants';
import { IDisplay } from 'slices/dataAnalyticsDisplaySlice';
import { ReactComponent as ChartStackedBarHorizontal } from 'assets/images/icons/campaign-data-analytics/biểu đồ cột chồng.svg';
import { ReactComponent as ChartStackedBarHorizontalActive } from 'assets/images/icons/campaign-data-analytics/biểu đồ cột chồng active.svg';
import { ReactComponent as ChartStackedBarVertical } from 'assets/images/icons/campaign-data-analytics/biểu đồ cột chồng dọc.svg';
import { ReactComponent as ChartStackedBarVerticalActive } from 'assets/images/icons/campaign-data-analytics/biểu đồ cột chồng dọc active.svg';
import { ReactComponent as ChartPie } from 'assets/images/icons/campaign-data-analytics/biểu đồ tròn.svg';
import { ReactComponent as ChartPieActive } from 'assets/images/icons/campaign-data-analytics/biểu đồ tròn active.svg';
import { ReactComponent as ChartDonut } from 'assets/images/icons/campaign-data-analytics/biểu đồ tròn donut.svg';
import { ReactComponent as ChartDonutActive } from 'assets/images/icons/campaign-data-analytics/biểu đồ tròn donut active.svg';
import QuestionStackedColumnChartCompare from './charts/question-stacked-column-chart-compare';
import QuestionPieCharts from './charts/question-pie-charts';
import QuestionBarMultiLine from './charts/question-bar-multi-line';
import { ReactComponent as ChartBarHorizontal } from 'assets/images/icons/campaign-data-analytics/chart bar ngang.svg';
import { ReactComponent as ChartBarHorizontalActive } from 'assets/images/icons/campaign-data-analytics/chart bar ngang active.svg';
import { ReactComponent as ChartBarVertical } from 'assets/images/icons/campaign-data-analytics/bar chart dọc.svg';
import { ReactComponent as ChartBarVerticalActive } from 'assets/images/icons/campaign-data-analytics/bar chart dọc active.svg';
import TableDataCompareResult from './table-data-compare-result';

interface ITableDataAnalyticsProps {
    tabActive: string;
}
export const listChartType = [
    {
        value: 'chartStackedBarHorizontal',
        icon: <ChartStackedBarHorizontal />,
        iconActive: <ChartStackedBarHorizontalActive />,
    },
    {
        value: 'chartStackedBarVertical',
        icon: <ChartStackedBarVertical />,
        iconActive: <ChartStackedBarVerticalActive />,
    },
    {
        value: 'chartPie',
        icon: <ChartPie />,
        iconActive: <ChartPieActive />,
    },
    {
        value: 'chartDonut',
        icon: <ChartDonut />,
        iconActive: <ChartDonutActive />,
    },
    {
        value: 'chartBarMultiLineHorizontal',
        icon: <ChartBarHorizontal />,
        iconActive: <ChartBarHorizontalActive />,
    },
    {
        value: 'chartBarMultiLineVertical',
        icon: <ChartBarVertical />,
        iconActive: <ChartBarVerticalActive />,
    },
];
const CompareResult: React.FC<ITableDataAnalyticsProps> = ({ tabActive }) => {
    const listQuestionsDataFilter = useAppSelector(
        (state: RootState) => state.questionDataFilter
    );
    const dataDisplay = useAppSelector(
        (state: RootState) => state.dataAnalyticsDisplay.display
    );
    const [chartActive, setChartActive] = React.useState<
        Record<number, string>
    >({});

    const shouldShowGraph = (tabActive: string, dataDisplay: IDisplay) => {
        return (
            tabActive === 'compare' ||
            dataDisplay.displayType.includes(DisplayType.GRAPH)
        );
    };

    useEffect(() => {
        if ((listQuestionsDataFilter || []).length > 0) {
            const defaultState: Record<number, string> = {};
            listQuestionsDataFilter?.forEach((q, index) => {
                defaultState[index] = 'chartStackedBarHorizontal';
            });
            setChartActive(defaultState);
        }
    }, [listQuestionsDataFilter, tabActive]);

    const handleTabChartChange = (questionId: number, newValue: string) => {
        setChartActive((prev) => ({
            ...prev,
            [questionId]: newValue,
        }));
    };

    // const shouldShowTableData = (tabActive: string, dataDisplay: IDisplay) => {
    //     return (
    //         tabActive === 'compare' ||
    //         dataDisplay.displayType.includes(DisplayType.DATA_TABLE)
    //     );
    // };
    return (
        <Box>
            {listQuestionsDataFilter.length > 0 && (
                <>
                    <Typography
                        variant="h5"
                        sx={{
                            fontSize: '28px',
                            fontWeight: 'bold',
                            color: colors.main,
                        }}
                        mt={3}
                        mb={3}
                    >
                        Kết quả so sánh
                    </Typography>
                    <Box
                        mt={2}
                        sx={{
                            backgroundColor: common.white,
                            borderRadius: '30px',
                            p: 3,
                        }}
                    >
                        {listQuestionsDataFilter?.map((question, index) => {
                            return (
                                <Box key={question.question_id}>
                                    <Box>
                                        <Typography
                                            variant="h5"
                                            sx={{
                                                mt: 2,
                                                fontWeight: 700,
                                                fontSize: '24px',
                                                lineHeight: '33.89px',
                                            }}
                                        >
                                            Câu {question.question_number}:{' '}
                                            {question.question_title}
                                        </Typography>
                                    </Box>

                                    <>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                            }}
                                            mt={2}
                                        >
                                            <Tabs
                                                TabIndicatorProps={{
                                                    style: {
                                                        display: 'none',
                                                    },
                                                }}
                                                value={
                                                    chartActive[index] ??
                                                    'bartChartHorizontal'
                                                }
                                                onChange={(_, newValue) =>
                                                    handleTabChartChange(
                                                        index,
                                                        newValue
                                                    )
                                                }
                                                aria-label="wrapped label tabs example"
                                                sx={{
                                                    '& .MuiTabs-flexContainer':
                                                        {
                                                            gap: 1,
                                                        },
                                                }}
                                            >
                                                {listChartType.map((item) => (
                                                    <Tab
                                                        key={item.value}
                                                        value={item.value}
                                                        icon={
                                                            chartActive[
                                                                index
                                                            ] === item.value
                                                                ? item.iconActive
                                                                : item.icon
                                                        }
                                                        sx={{
                                                            ...styles.tab,
                                                            '&.Mui-selected': {
                                                                backgroundColor:
                                                                    'primary.main',
                                                            },
                                                        }}
                                                    />
                                                ))}
                                            </Tabs>
                                        </Box>
                                        <Box
                                            sx={{
                                                mt: 2,
                                                p: 2,
                                                border: '1px solid #ddd',
                                                borderRadius: '8px',
                                            }}
                                        >
                                            {chartActive[index] === 'chartPie'
                                                ? [
                                                      QuestionType.SingleChoice,
                                                      QuestionType.TextboxRecommend,
                                                      QuestionType.TextboxRecommendMultiChoice,
                                                      QuestionType.Checkbox,
                                                      QuestionType.Score,
                                                      QuestionType.Emoji,
                                                      QuestionType.ScoreStarFull,
                                                      QuestionType.ScoreStarHalf,
                                                      QuestionType.Dropdown,
                                                      QuestionType.MatrixCheckbox,
                                                      QuestionType.MatrixRadio,
                                                      QuestionType.Rank,
                                                      QuestionType.SliderScale,
                                                  ].includes(
                                                      question.question_type as QuestionType
                                                  ) && (
                                                      <>
                                                          {shouldShowGraph(
                                                              tabActive,
                                                              dataDisplay
                                                          ) && (
                                                              <>
                                                                  <QuestionPieCharts
                                                                      data={
                                                                          question.data
                                                                      }
                                                                      type="pie"
                                                                  />
                                                              </>
                                                          )}
                                                      </>
                                                  )
                                                : null}
                                            {chartActive[index] === 'chartDonut'
                                                ? [
                                                      QuestionType.SingleChoice,
                                                      QuestionType.TextboxRecommend,
                                                      QuestionType.TextboxRecommendMultiChoice,
                                                      QuestionType.Checkbox,
                                                      QuestionType.Score,
                                                      QuestionType.Emoji,
                                                      QuestionType.ScoreStarFull,
                                                      QuestionType.ScoreStarHalf,
                                                      QuestionType.Dropdown,
                                                      QuestionType.MatrixCheckbox,
                                                      QuestionType.MatrixRadio,
                                                      QuestionType.Rank,
                                                      QuestionType.SliderScale,
                                                  ].includes(
                                                      question.question_type as QuestionType
                                                  ) && (
                                                      <>
                                                          {shouldShowGraph(
                                                              tabActive,
                                                              dataDisplay
                                                          ) && (
                                                              <>
                                                                  <QuestionPieCharts
                                                                      data={
                                                                          question.data
                                                                      }
                                                                      type="donut"
                                                                  />
                                                              </>
                                                          )}
                                                      </>
                                                  )
                                                : null}

                                            {chartActive[index] ===
                                            'chartStackedBarHorizontal'
                                                ? [
                                                      QuestionType.SingleChoice,
                                                      QuestionType.TextboxRecommend,
                                                      QuestionType.TextboxRecommendMultiChoice,
                                                      QuestionType.Checkbox,
                                                      QuestionType.Score,
                                                      QuestionType.ScoreStarFull,
                                                      QuestionType.ScoreStarHalf,
                                                      QuestionType.Emoji,
                                                      QuestionType.Dropdown,
                                                      QuestionType.MatrixCheckbox,
                                                      QuestionType.MatrixRadio,
                                                      QuestionType.Rank,
                                                      QuestionType.SliderScale,
                                                  ].includes(
                                                      question.question_type as QuestionType
                                                  ) && (
                                                      <>
                                                          {shouldShowGraph(
                                                              tabActive,
                                                              dataDisplay
                                                          ) && (
                                                              <QuestionStackedColumnChartCompare
                                                                  layout="horizontal"
                                                                  data={
                                                                      question?.data
                                                                  }
                                                              />
                                                          )}
                                                      </>
                                                  )
                                                : null}

                                            {chartActive[index] ===
                                            'chartStackedBarVertical'
                                                ? [
                                                      QuestionType.SingleChoice,
                                                      QuestionType.TextboxRecommend,
                                                      QuestionType.TextboxRecommendMultiChoice,
                                                      QuestionType.Checkbox,
                                                      QuestionType.Score,
                                                      QuestionType.Emoji,
                                                      QuestionType.ScoreStarFull,
                                                      QuestionType.ScoreStarHalf,
                                                      QuestionType.Dropdown,
                                                      QuestionType.MatrixCheckbox,
                                                      QuestionType.MatrixRadio,
                                                      QuestionType.Rank,
                                                      QuestionType.SliderScale,
                                                  ].includes(
                                                      question.question_type as QuestionType
                                                  ) && (
                                                      <>
                                                          {shouldShowGraph(
                                                              tabActive,
                                                              dataDisplay
                                                          ) && (
                                                              <QuestionStackedColumnChartCompare
                                                                  layout="vertical"
                                                                  data={
                                                                      question?.data
                                                                  }
                                                              />
                                                          )}
                                                      </>
                                                  )
                                                : null}

                                            {chartActive[index] ===
                                            'chartBarMultiLineHorizontal'
                                                ? [
                                                      QuestionType.SingleChoice,
                                                      QuestionType.TextboxRecommend,
                                                      QuestionType.TextboxRecommendMultiChoice,
                                                      QuestionType.Checkbox,
                                                      QuestionType.Score,
                                                      QuestionType.Emoji,
                                                      QuestionType.ScoreStarFull,
                                                      QuestionType.ScoreStarHalf,
                                                      QuestionType.Dropdown,
                                                      QuestionType.MatrixCheckbox,
                                                      QuestionType.MatrixRadio,
                                                      QuestionType.Rank,
                                                      QuestionType.SliderScale,
                                                  ].includes(
                                                      question.question_type as QuestionType
                                                  ) && (
                                                      <>
                                                          {shouldShowGraph(
                                                              tabActive,
                                                              dataDisplay
                                                          ) && (
                                                              <QuestionBarMultiLine
                                                                  layout="horizontal"
                                                                  data={
                                                                      question?.data_y_category
                                                                  }
                                                              />
                                                          )}
                                                      </>
                                                  )
                                                : null}
                                            {chartActive[index] ===
                                            'chartBarMultiLineVertical'
                                                ? [
                                                      QuestionType.SingleChoice,
                                                      QuestionType.TextboxRecommend,
                                                      QuestionType.TextboxRecommendMultiChoice,
                                                      QuestionType.Checkbox,
                                                      QuestionType.Score,
                                                      QuestionType.Emoji,
                                                      QuestionType.ScoreStarFull,
                                                      QuestionType.ScoreStarHalf,
                                                      QuestionType.Dropdown,
                                                      QuestionType.MatrixCheckbox,
                                                      QuestionType.MatrixRadio,
                                                      QuestionType.Rank,
                                                      QuestionType.SliderScale,
                                                  ].includes(
                                                      question.question_type as QuestionType
                                                  ) && (
                                                      <>
                                                          {shouldShowGraph(
                                                              tabActive,
                                                              dataDisplay
                                                          ) && (
                                                              <QuestionBarMultiLine
                                                                  layout="vertical"
                                                                  data={
                                                                      question?.data_y_category
                                                                  }
                                                              />
                                                          )}
                                                      </>
                                                  )
                                                : null}

                                            <Box mt={1}>
                                                {[
                                                    QuestionType.SingleChoice,
                                                    QuestionType.TextboxRecommend,
                                                    QuestionType.TextboxRecommendMultiChoice,
                                                    QuestionType.Checkbox,
                                                    QuestionType.Score,
                                                    QuestionType.Emoji,
                                                    QuestionType.ScoreStarFull,
                                                    QuestionType.ScoreStarHalf,
                                                    QuestionType.Dropdown,
                                                    QuestionType.MatrixCheckbox,
                                                    QuestionType.MatrixRadio,
                                                    QuestionType.Rank,
                                                    QuestionType.SliderScale,
                                                ].includes(
                                                    question.question_type as QuestionType
                                                ) && (
                                                    <>
                                                        <TableDataCompareResult
                                                            data={question.data}
                                                        />
                                                    </>
                                                )}{' '}
                                            </Box>
                                        </Box>
                                    </>
                                </Box>
                            );
                        })}
                    </Box>
                </>
            )}
        </Box>
    );
};

const styles = createStyleSheet({
    tab: {
        minWidth: '40px',
        width: '40px',
        minHeight: '40px',
        height: '40px',
        padding: '0px',
        backgroundColor: '#0000000D',
        borderRadius: '0px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});
export default CompareResult;
